// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"b902c203","197":"54ccb0f4","337":"770bfac4","379":"94b3cca0","551":"d93adf11","687":"560f57a5","773":"8ad05bcd"}[chunkId] + ".chunk.css";
};